import React, { useEffect, useState } from 'react';
import { ColCard } from '../ContentLayout';
import { isEmpty } from '../../utils/lodashExtend';
import Button from '../Button';
import Loading from '../Loading';
import { onLoadMultiImage } from '../../utils/image';
import IconButton from '../Button/IconButton';
import NoData from '../NoData/NoData';
import { classnames } from '../../utils/text';
import DeleteIcon from '../../assets/images/icon/delete-icon.svg';
import { get } from 'lodash';
import { dateToViewFormat } from '../../utils/date';
import EmployeeSignCreate from './EmployeeSignCreate';
import { changeAvailable, deleteSign, mySignList } from '../../apis/employee/employee-sign';
import systemAlert from '../../utils/systemAlert';
import { toast } from '../../utils/toast';
import { useDispatch } from 'react-redux';
import { setProfile } from '../../store/actions';

const EmployeeSigns = ({ ...props }) => {
  const tableHeight = 200;
  const [employeeSignLst, setEmployeeSignList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [mode, setMode] = useState("detail");
  const [open, setOpen] = useState(false);
  const [headerButtons, setHeaderButtons] = useState([
    {
      color: "gray-line",
      label: "편집하기",
      size: "sm",
      action: () => {
        setMode("modify");
      },
    }
  ]);

  const dispatch = useDispatch();

  const reloadMyInfo = () => {
    dispatch(setProfile());
  };

  useEffect(() => {
    mode === "detail"
      ? setHeaderButtons([
        {
          color: "gray-line",
          label: "편집하기",
          size: "sm",
          action: () => {
            setMode("modify");
          },
        },
        {
          color: "line",
          label: "새 서명",
          size: "sm",
          action: () => {
            setOpen(true);
          },
        }
      ])
      : setHeaderButtons([
        {
          label: "완료",
          size: "sm",
          action: () => {
            setMode("detail");
          },
        },
      ]);
  }, [mode]);

  const handleOnImageClick = (data) => {
    if (mode === "detail") {
      if (data.file) {

        data.file.fileUrl = data.fileUri;
        onLoadMultiImage([data.file], 0);
      } else {
        onLoadMultiImage([{ title: "직접서명", fileUrl: data.fileUri }], 0);
      }
    }
  };

  const handleOnRemove = (data) => {

    const body = {
      idx: [data.idx]
    };

    systemAlert("서명을 삭제하시겠습니까?", {
      buttons: [
        {
          color: "text",
          label: "취소",
        },
        {
          label: "확인",
          onClick: () => {
            deleteSign(body)
              .then(() => {
                reloadMyInfo();
                toast.success("서명이 삭제되었습니다.");
                submit();
              })
              .catch((err) => {
                console.error(err.response);
              });
          },
        },
      ],
    });
  };



  const handleOnAvailable = (data) => {
    setIsLoading(true);
    const body = {
      available: !data.available
    };
    changeAvailable(data.idx, body)
      .then(() => {
        reloadMyInfo();
        submit();
      })
      .catch((err) => console.error(err))
      .finally(() => { setIsLoading(false); });
  };

  useEffect(() => {
    submit();
  }, []);

  const submit = () => {
    setIsLoading(true);
    mySignList()
      .then(res => setEmployeeSignList(res.data))
      .catch(err => console.error(err))
      .finally(() => setIsLoading(false));
  };

  return (
    <>
      <div className="AdditionalInfo">
        <ColCard cardBody={{ className: "p-0" }}>
          <div className="card-header">
            <span className="additional-card-title">나의 서명</span>
            <div className="button-wrap">
              {!isEmpty(headerButtons) &&
                headerButtons.map((button, idx) => (
                  <Button {...button} key={idx} className="margin-left-8" />
                ))}
            </div>
          </div>
          <div className="additional-card-body">
            {isLoading ? (
              <Loading minHeight={tableHeight} />
            ) : isEmpty(employeeSignLst) ? (
              <NoData />
            ) : (
              employeeSignLst.map((data, idx) => (
                <div className="list-wrapper" key={idx}>
                  <div className="list-item">
                    <div
                      className="image-wrap"
                      // style={{ backgroundImage: `url(${get(data, "file.url")})` }}
                      onClick={() => handleOnImageClick(data)}
                    >
                      <img className={classnames("additional-img", "sign")} src={get(data, "fileUri")} alt={get(data, "fileUri")} />
                      {mode === "modify" && (
                        <IconButton
                          icon={DeleteIcon}
                          className="delete-btn"
                          onClick={() => handleOnRemove(data)}
                        />
                      )}
                      {mode === "modify" ? (
                        (get(data, "available") ? (
                          <span className="available-tag true" onClick={() => handleOnAvailable(data)}>유효</span>
                        ) : (
                          <span className="available-tag false" onClick={() => handleOnAvailable(data)} >만료</span>
                        ))
                      ) : ((get(data, "available") ? (
                        <span className="available-tag true">유효</span>
                      ) : (
                        <span className="available-tag false">만료</span>
                      ))
                      )}
                    </div>
                    <p className="created-date">
                      {dateToViewFormat(data.createdTime)}
                    </p>
                  </div>
                </div>
              ))
            )}
          </div>
        </ColCard>
        <EmployeeSignCreate
          open={open}
          setOpen={setOpen}
          submit={submit}
          isAvailable={!isEmpty(employeeSignLst.find(f => !!f.available))}
          reloadMyInfo={reloadMyInfo}
        />
      </div>
    </>
  );
};

export default EmployeeSigns;